export const PAGE_TITLE = "Blooddonations";
export const PAGE_SINGLE_TITLE = "Blooddonation";
export const LINK_URL = "blooddonations";
export const SEARCH_TERMS = ["title", "meta_title"];
export const inputFields = {
    name: {
        type: "string",
        required: true,
        title: "Title",
    },
    phone: {
        type: "string",
        required: true,
        title: "Phone",
    },
    email: {
        type: "string",
        required: true,
        title: "Email",
    },
    blood_group: {
        type: "string",
        required: true,
        title: "Blood Group",
    },
    message: {
        type: "text",
        required: false,
        title: "Message",
    },
};
export const initialValues = {
    name: "",
    phone: "",
    email: "",
    blood_group: "",
    message: "",
};

export const view_all_table = [
    { name: "Name", value: "name" },
    { name: "Phone", value: "phone" },
    { name: "Email", value: "email" },
    { name: "BloodGroup", value: "blood_group" },
    { name: "Message", value: "message" },
];
